import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BlockListService {

  private apiURL = environment.apiBaseUrl + '/blockList';

  constructor(private http: HttpClient) { }

  getBlockList(): Observable<any> {
    const timestamp = new Date().getTime();

    return this.http.get<any>(`${this.apiURL}?timestamp=${timestamp}`);
  }

  addBlocklist(nome: string, telefono: string): Observable<any> {
    return this.http.post<any>(this.apiURL, { nome: nome, telefono: telefono});
  }

  deleteBlocklist(id: string): Observable<any> {
    return this.http.delete(`${this.apiURL}/${id}`);
  }
}
